export default [
  {
    title: 'Разместить рекламу',
    route: '/advertising/',
    slug: '/advertising/',
    id: 1,
    parent: null,
  },
  {
    title: 'Автосалонам',
    route: '/for-dealers/',
    slug: '/for-dealers/',
    id: 2,
    parent: null,
  },
  {
    title: 'Бизнесу',
    route: '/biznes-paket/',
    slug: '/biznes-paket/',
    id: 2003180232,
    parent: null,
  },
  {
    title: 'Запчасти',
    route: '/info-zapchasti/',
    slug: '/info-zapchasti/',
    id: 2103181339,
    parent: null,
  },

  {
    title: 'Автосервисам',
    route: '/for-services/',
    slug: '/for-services/',
    id: 3,
    parent: null,
  },
  {
    title: 'Услуги для частных лиц',
    route: '/for-privates/',
    slug: '/for-privates/',
    id: 2103181356,
    parent: null,
  },
  {
    title: 'Публичный договор',
    route: '/public-contract/',
    slug: '/public-contract/',
    id: null,
    parent: null,
  },
  {
    title: 'Правила публикации объявлений',
    route: '/advertising-conditions/',
    slug: '/advertising-conditions/',
    id: null,
    parent: null,
  },
  {
    title: 'Политика конфиденциальности',
    route: '/law/',
    slug: '/law/',
    id: 11,
    parent: null,
  },
  {
    title: 'О проекте',
    route: '/about/',
    slug: '/about/',
    id: 6,
    parent: null,
  },
  {
    title: 'Помощь',
    route: '/help/',
    slug: '/help/',
    id: 4,
    parent: null,
  },
];



// WEBPACK FOOTER //
// ./src/shared/constants/staticPagesNavigation.js